export default "__VITE_ASSET__a6b20794__"